module.exports = __webpack_public_path__ + "img/intelligent-m1.5f44d403.png";